// PRODUÇÃO
const URL_BASE = "https://imob86.concept.inf.br/Imob86/Vue";
// HOMOLOGAÇÃO
//const URL_BASE = "http://10.10.1.62:8080/Imob86/Vue";
// DESENVOLVIMENTO
//const URL_BASE = "http://10.10.1.22:8080/Imob86/Vue";

const ADMINISTRADORAS_LISTAR = URL_BASE + "/Administradoras/Listar";
const ADMINISTRADORAS_RECUPERAR = URL_BASE + "/Administradoras/Recuperar";
const ADMINISTRADORAS_GRAVAR = URL_BASE + "/Administradoras/Gravar";
const ADMINISTRADORAS_REMOVER = URL_BASE + "/Administradoras/Remover";
const ADMINISTRADORAS_ADICIONAR_CONDOMINIO = URL_BASE + "/Administradoras/AdicionarCondominio";
const ADMINISTRADORAS_REMOVER_CONDOMINIO = URL_BASE + "/Administradoras/RemoverCondominio";

// ALUGUEIS
const ALUGUEIS_VERIFICAR_APROVACAO = URL_BASE + "/Alugueis/VerificarAprovacao";
const ALUGUEIS_APROVAR = URL_BASE + "/Alugueis/Aprovar";
const ALUGUEIS_DESAPROVAR = URL_BASE + "/Alugueis/Desaprovar";
const ALUGUEIS_DESOCUPAR = URL_BASE + "/Alugueis/Desocupar";
const ALUGUEIS_CALCULAR_FINALIZACAO = URL_BASE + "/Alugueis/CalcularFinalizacao";
const ALUGUEIS_FINALIZAR_CONCLUIDO = URL_BASE + "/Alugueis/FinalizarConcluido";
const ALUGUEIS_FINALIZAR = URL_BASE + "/Alugueis/Finalizar";
const ALUGUEIS_FINALIZAR_COM_RESTRICOES = URL_BASE + "/Alugueis/FinalizarComRestricoes";
const ALUGUEIS_CANCELAR_FINALIZACAO = URL_BASE + "/Alugueis/CancelarFinalizacao";
const ALUGUEIS_ATUALIZAR_SITUACAO_JURIDICA = URL_BASE + "/Alugueis/AtualizarSituacaoJuridica";
const ALUGUEIS_CANCELAR_DESOCUPACAO = URL_BASE + "/Alugueis/CancelarDesocupacao";
const ALUGUEIS_GRAVAR = URL_BASE + "/Alugueis/Gravar";
const ALUGUEIS_ALTERAR_DATA_REAJUSTE = URL_BASE + "/Alugueis/AlterarDataReajuste";
const ALUGUEIS_DESFAZER_ALTERACAO_DATA_REAJUSTE = URL_BASE + "/Alugueis/DesfazerAlteracaoDataReajuste"
const ALUGUEIS_REMOVER = URL_BASE + "/Alugueis/Remover";
const ALUGUEIS_DESARQUIVAR = URL_BASE + "/Alugueis/Desarquivar";
const ALUGUEIS_LISTAR = URL_BASE + "/Alugueis/Listar";
const ALUGUEIS_RECUPERAR = URL_BASE + "/Alugueis/Recuperar";
const ALUGUEIS_REAJUSTAR = URL_BASE + "/Alugueis/Reajustar";
const ALUGUEIS_CANCELAR_REAJUSTE = URL_BASE + "/Alugueis/CancelarReajuste";
const ALUGUEIS_RENOVAR = URL_BASE + "/Alugueis/Renovar";
const ALUGUEIS_CANCELAR_RENOVACAO = URL_BASE + "/Alugueis/CancelarRenovacao";
const ALUGUEIS_ALTERAR_RENOVACAO = URL_BASE + "/Alugueis/AlterarRenovacao";
const ALUGUEIS_PRORROGAR = URL_BASE + "/Alugueis/Prorrogar";
const ALUGUEIS_CANCELAR_PRORROGACAO = URL_BASE + "/Alugueis/CancelarProrrogacao";
const ALUGUEIS_ALTERAR_TAXA_ADMINISTRACAO = URL_BASE + "/Alugueis/AlterarTaxaAdministracao";
const ALUGUEIS_ULTIMA_TAXA_ADM_COMPLEMENTAR = URL_BASE + "/Alugueis/RecuperarUltimaTaxaAdministracaoComplementar";
const ALUGUEIS_RECUPERAR_MES_SERIE_PARA_FINALIZACAO = URL_BASE + "/Alugueis/RecuperarMesSerieParaFinalizacao";
const ALUGUEIS_RECUPERAR_RECIBOS_DESCONTO_POR_ACORDO = URL_BASE + "/Alugueis/RecuperarRecibosDescontoPorAcordo";
const ALUGUEIS_GRAVAR_DESCONTOS = URL_BASE + "/Alugueis/GravarDescontos"
const ALUGUEIS_GRAVAR_DESCONTOS_SALDO_NEGATIVO = URL_BASE + "/Alugueis/GravarDescontosSaldoNegativo"
const ALUGUEIS_REMOVER_DESCONTO = URL_BASE + "/Alugueis/RemoverDesconto"
const ALUGUEIS_ALTERAR_DATA_VENCIMENTO = URL_BASE + "/Alugueis/AlterarVencimento";
const ALUGUEIS_CANCELAR_ALTERACAO_VENCIMENTO = URL_BASE + "/Alugueis/CancelarAlteracaoVencimento";
const ALUGUEIS_EXIBIR_RESUMO_CONTRATO = URL_BASE + "/Alugueis/ExibirResumoContrato";
const ALUGUEIS_ALTERAR_VALOR_CONTRATO = URL_BASE + "/Alugueis/AlterarValorContrato";
const ALUGUEIS_ALTERAR_CARENCIA_CONTRATO = URL_BASE + "/Alugueis/AlterarCarencia";
const ALUGUEIS_RECUPERAR_ENVOLVIDOS = URL_BASE + "/Alugueis/RecuperarEnvolvidos";
const ALUGUEIS_GRAVAR_LANCAMENTO_FUTURO = URL_BASE + "/Alugueis/GravarLancamentoFuturo";
const ALUGUEIS_REMOVER_LANCAMENTO_FUTURO = URL_BASE + "/Alugueis/RemoverLancamentoFuturo"
const ALUGUEIS_REMOVER_COBRANCAS_RECIBO = URL_BASE + "/Alugueis/RemoverCobrancasRecibo";
const ALUGUEIS_REMOVER_REGISTRO_RECIBOS_CONTRATO = URL_BASE + "/Alugueis/RemoverRegistros"

//ARQUIVOS
const ARQUIVOS_UPLOAD = URL_BASE + "/Arquivos/Gravar"
const ARQUIVOS_REMOVER = URL_BASE + "/Arquivos/Remover"
const ARQUIVOS_CRIAR_DIRETORIO = URL_BASE + "/Arquivos/CriarDiretorio"
const ARQUIVOS_REMOVER_DIRETORIO = URL_BASE + "/Arquivos/RemoverDiretorio"
const ARQUIVOS_LISTAR_DIRETORIOS = URL_BASE + "/Arquivos/ListarDiretorios"
const ARQUIVOS_SELECIONAR_DIRETORIO = URL_BASE + "/Arquivos/SelecionarDiretorio"

const ARQUIVO_RETORNO_LISTAR = URL_BASE + "/ArquivoRetorno/Listar"
const ARQUIVO_RETORNO_PROCESSAR = URL_BASE + "/ArquivoRetorno/ProcessarArquivo"

const ATENDIMENTOS_LISTAR = URL_BASE + "/Atendimentos/Listar";
const ATENDIMENTOS_RECUPERAR = URL_BASE + "/Atendimentos/Recuperar";
const ATENDIMENTOS_CONCLUIR_PRE_CADASTRO = URL_BASE + "/Atendimentos/ConcluirPreCadastro";
const ATENDIMENTOS_CONCLUIR_CRIACAO_PERFIL = URL_BASE + "/Atendimentos/ConcluirCriacaoPerfil";
const ATENDIMENTOS_GRAVAR_IMOVEIS = URL_BASE + "/Atendimentos/GravarImoveis";
const ATENDIMENTOS_GRAVAR_VISITA = URL_BASE + "/Atendimentos/GravarVisita";
const ATENDIMENTOS_GRAVAR_AVALIACAO_VISITA = URL_BASE + "/Atendimentos/GravarAvaliacaoVisita";
const ATENDIMENTOS_LISTAR_IMOVEIS_SEMELHANTES = URL_BASE + "/Atendimentos/ListarImoveisSemelhantes";
const ATENDIMENTOS_GERAR_PROPOSTA = URL_BASE + "/Atendimentos/ConcluirProposta";
const ATENDIMENTOS_ENVIAR_PROPOSTA_ASSINATURA = URL_BASE + "/ZapSign/AssinaturaProposta";
const ATENDIMENTOS_CONCLUIR_PROPOSTA_MANUALMENTE = URL_BASE + "/Atendimentos/ConcluirPropostaManual";
const ATENDIMENTOS_REMOVER = URL_BASE + "/Atendimentos/Remover";
const ATENDIMENTOS_CANCELAR = URL_BASE + "/Atendimentos/CancelarAtendimento";
const ATENDIMENTOS_CANCELAR_ASSINATURA_PROPOSTA = URL_BASE + "/ZapSign/CancelarAssinaturaProposta";
const ATENDIMENTOS_ATUALIZAR_PRE_CADASTRO = URL_BASE + "/Atendimentos/AtualizarPreCadastro";
const ATENDIMENTOS_ATUALIZAR_CRIACAO_PERFIL = URL_BASE + "/Atendimentos/AtualizarCriacaoPerfil";
const ATENDIMENTOS_REMOVER_IMOVEL_SEMELHANTE = URL_BASE + "/Atendimentos/RemoverImovelSemelhante";
const ATENDIMENTOS_ENVIAR_PROPOSTA_MANUAL = URL_BASE + "/Atendimentos/EnviarPropostaManual";
const ATENDIMENTOS_GERAR_PROPOSTA_MANUAL = URL_BASE + "/Atendimentos/GerarDocumentoProposta";
const ATENDIMENTOS_CANCELAR_PROPOSTA = URL_BASE + "/Atendimentos/CancelarPropostaSemAssinatura"

const BAIRROS_LISTAR = URL_BASE + "/Bairros/Listar";
//BOLETOS
const BOLETOS_AVULSOS_GRAVAR = URL_BASE + "/BoletosAvulsos/Gravar";
const BOLETOS_AVULSOS_REMOVER = URL_BASE + "/BoletosAvulsos/Remover";
const BOLETOS_AVULSOS_RECUPERAR = URL_BASE + "/BoletosAvulsos/Recuperar";
const BOLETOS_AVULSOS_GERAR = URL_BASE + "/BoletosAvulsos/Gerar";
const BOLETOS_AVULSOS_GERAR_BOLETOS = URL_BASE + "/BoletosAvulsos/GerarBoletosEmAberto";
const BOLETOS_AVULSOS_ENVIAR_BOLETO_POR_EMAIL = URL_BASE + "/BoletosAvulsos/EnviarBoletoAvulso";
const BOLETOS_AVULSOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL = URL_BASE + "/BoletosAvulsos/EnviarBoletosEmAbertoPorEmail";
const BOLETOS_AVULSOS_LISTAR_BAIXAS = URL_BASE + "/BoletosAvulsos/ListarBaixas";
const BOLETOS_AVULSOS_PAGAR = URL_BASE + "/BoletosAvulsos/Pagar";
const BOLETOS_AVULSOS_CANCELAR_PAGAMENTO = URL_BASE + "/BoletosAvulsos/CancelarPagamento";
const BOLETOS_AVULSOS_RECUPERAR_ENVOLVIDOS = URL_BASE + "/BoletosAvulsos/RecuperarEnvolvidos";
const BOLETOS_AVULSOS_PRORROGAR = URL_BASE + "/BoletosAvulsos/ProrrogarBoletoAvulso";
const BOLETOS_AVULSOS_CALCULAR = URL_BASE + "/BoletosAvulsos/CalcularBoletoAvulso";
const BOLETOS_AVULSOS_CANCELAR_PRORROGACAO = URL_BASE + "/BoletosAvulsos/CancelarProrrogacaoBoletoAvulso";

const CAIXAS_RECUPERAR_CAIXA_ABERTO = URL_BASE + "/Caixas/RecuperarCaixaAberto";
const CAIXAS_RECUPERAR_CHEQUES_NO_CAIXA = URL_BASE + "/Caixas/RecuperarChequesNoCaixa";
const CAIXAS_ABRIR = URL_BASE + "/Caixas/Abrir";
const CAIXAS_FECHAR = URL_BASE + "/Caixas/Fechar";
const CAIXAS_GRAVAR_LANCAMENTO = URL_BASE + "/Caixas/GravarLancamento";
const CAIXAS_REMOVER_LANCAMENTO = URL_BASE + "/Caixas/RemoverLancamento";
const CAIXAS_RECUPERAR_HISTORICO = URL_BASE + "/Caixas/RecuperarHistorico";
const CAIXAS_RECUPERAR_CAIXA_ANTERIOR = URL_BASE + "/Caixas/RecuperarCaixaAnterior";
const CAIXAS_RECUPERAR_HISTORICO_CHEQUE = URL_BASE + "/Caixas/RecuperarHistoricoCheque";
const CAIXAS_RECUPERAR_SALDO = URL_BASE + "/Caixas/RecuperarSaldo";

const CARACTERISTICAS_CONDOMINIO_LISTAR = URL_BASE + "/CaracteristicasCondominio/Listar";
const CARACTERISTICAS_IMOVEL_LISTAR = URL_BASE + "/CaracteristicasImovel/Listar";

const CIDADES_LISTAR = URL_BASE + "/Cidades/Listar";

const CLIENTES_LISTAR = URL_BASE + "/Clientes/Listar";
const CLIENTES_RECUPERAR = URL_BASE + "/Clientes/Recuperar";
const CLIENTES_GRAVAR = URL_BASE + "/Clientes/Gravar";
const CLIENTES_REATIVAR = URL_BASE + "/Clientes/Reativar";
const CLIENTES_REMOVER = URL_BASE + "/Clientes/Remover";
//const CLIENTES_VERIFICAR_TELEFONE = URL_BASE + "/Clientes/VerificarTelefone";
const CLIENTES_GRAVAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/GravarContatoRealizado";
const CLIENTES_ATUALIZAR_CONTATO_REALIZADO = URL_BASE + "/Clientes/AtualizarContatoRealizado";
const CLIENTES_REMOVER_CONTATO_REALIZADO = URL_BASE + "/Clientes/RemoverContatoRealizado";
//const CLIENTES_CONCLUIR_CONTATO = URL_BASE + "/Clientes/ConcluirContato";
//const CLIENTES_REATIVAR = URL_BASE + "/Clientes/Reativar";
const CLIENTES_GRAVAR_CONTA_BANCARIA = URL_BASE + "/Clientes/GravarContaBancaria";
const CLIENTES_REMOVER_CONTA_BANCARIA = URL_BASE + "/Clientes/RemoverContaBancaria";
const CLIENTES_REMOVER_CONTA_BANCARIA_COM_REPASSE = URL_BASE + "/Clientes/RemoverContaBancariaComRepasse";
const CLIENTES_RECUPERAR_VISITA = URL_BASE + "/Clientes/RecuperarVisita";
const CLIENTES_GRAVAR_VISITA = URL_BASE + "/Clientes/GravarVisita";
const CLIENTES_REMOVER_VISITA = URL_BASE + "/Clientes/RemoverVisita";
const CLIENTES_GRAVAR_REGISTRO_COBRANCA = URL_BASE + "/Clientes/GravarCobranca"
const CLIENTES_LISTAR_COBRANCAS = URL_BASE + "/Clientes/ListarCobrancas";
const COBRANCAS_REMOVER = URL_BASE + "/Clientes/RemoverCobranca";
const CLIENTES_ATUALIZAR_REPRESENTANTE = URL_BASE + "/Clientes/AtualizarRepresentante"

const CONDOMINIOS_LISTAR = URL_BASE + "/Condominios/Listar";
const CONDOMINIOS_GRAVAR = URL_BASE + "/Condominios/Gravar";
const CONDOMINIOS_RECUPERAR = URL_BASE + "/Condominios/Recuperar";
const CONDOMINIOS_REMOVER = URL_BASE + "/Condominios/Remover";

//CONTAS RECEBER/PAGAR
const CONTAS_LISTAR = URL_BASE + "/Contas/Listar";
const CONTAS_GRAVAR = URL_BASE + "/Contas/Gravar";
const CONTAS_APROVAR = URL_BASE + "/Contas/Aprovar";
const CONTAS_DESAPROVAR = URL_BASE + "/Contas/Desaprovar";
const CONTAS_DUPLICAR = URL_BASE + "/Contas/Duplicar";
const CONTAS_CRIAR_CONTA_MENSALIDADES = URL_BASE + "/Contas/CriarContaMensalidades";
const CONTAS_RECUPERAR = URL_BASE + "/Contas/Recuperar";
const CONTAS_CANCELAR = URL_BASE + "/Contas/Cancelar";
const CONTAS_REMOVER = URL_BASE + "/Contas/Remover";
const CONTAS_FECHAR = URL_BASE + "/Contas/FecharConta";
const CONTAS_REABRIR = URL_BASE + "/Contas/ReabrirConta";

const CONTAS_BANCARIAS_LISTAR = URL_BASE + "/ContasBancarias/Listar";
const CONTAS_BANCARIAS_RECUPERAR = URL_BASE + "/ContasBancarias/Recuperar";
const CONTAS_BANCARIAS_GRAVAR = URL_BASE + "/ContasBancarias/Gravar";
const CONTAS_BANCARIAS_REMOVER = URL_BASE + "/ContasBancarias/Remover";
const CONTAS_BANCARIAS_LISTAR_WEBHOOKS_ASAAS = URL_BASE + "/AsaasApi/ListarWebhooks"
const CONTAS_BANCARIAS_REMOVER_WEBHOOK_ASAAS = URL_BASE + "/AsaasApi/RemoverWebhook"
const CONTAS_BANCARIAS_ADICIONAR_WEBHOOK_PAGAMENTOS = URL_BASE + "/AsaasApi/NovoWebhookPagamentos"

//DASHBOARDS
const DASHBOARD_LISTAR_IMOVEIS_MAPA = URL_BASE + "/Dashboard/ListarImoveisMapa";
const DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_VENDIDOS_GRAFICO = URL_BASE + "/Dashboard/ListarImoveisCaptadosVendidos";
const DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_ALUGADOS_GRAFICO = URL_BASE + "/Dashboard/ListarImoveisCaptadosAlugados";
const DASHBOARD_LISTAR_ATENDIMENTOS_GRAFICO = URL_BASE + "/Dashboard/ListarAtendimentos";
const DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL = URL_BASE + "/Dashboard/RecuperarSumarioTipoImovel";
const DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioTipoImovelImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_STATUS = URL_BASE + "/Dashboard/RecuperarSumarioStatus";
const DASHBOARD_RECUPERAR_SUMARIO_STATUS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioStatusImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_LOCATARIOS_INADIPLENTES = URL_BASE + "/Dashboard/RecuperarLocatariosInadiplentesAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_RECEITA_ALUGUEL_MES = URL_BASE + "/Dashboard/RecuperarSumarioReceitaAluguelMes"
const DASHBOARD_RECUPERAR_GESTAO_ALUGUEL_MES_ATUAL = URL_BASE + "/Dashboard/RecuperarGestaoAluguelMesAtual"
const DASHBOARD_RECUPERAR_SUMARIO_FOTOS = URL_BASE + "/Dashboard/RecuperarSumarioFotos";
const DASHBOARD_RECUPERAR_SUMARIO_FOTOS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioFotosImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO = URL_BASE + "/Dashboard/RecuperarSumarioLocalizacao";
const DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/RecuperarSumarioLocalizacaoImoveisAluguel";
const DASHBOARD_RECUPERAR_SUMARIO_ATENDIMENTO = URL_BASE + "/Dashboard/RecuperarSumarioAtendimento";
const DASHBOARD_IMOVEIS_CAPTADOS = URL_BASE + "/Dashboard/ImoveisCaptados";
const DASHBOARD_IMOVEIS_VENDIDOS = URL_BASE + "/Dashboard/ImoveisVendidos";
const DASHBOARD_RECUPERAR_ALUGUEIS_ATRASADOS = URL_BASE + "/Dashboard/AlugueisAtrasados";
const DASHBOARD_RECUPERAR_ALUGUEIS_DO_DIA = URL_BASE + "/Dashboard/AlugueisAtrasadosDoDia";
const DASHBOARD_RECUPERAR_ALUGUEIS_MES_ANTERIOR = URL_BASE + "/Dashboard/AlugueisAtrasadosMesAnterior";
const DASHBOARD_RECUPERAR_CONTRATOS_VENCIDOS = URL_BASE + "/Dashboard/ContratosVencidos";
const DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_VENDA = URL_BASE + "/Dashboard/UltimosImoveisVenda";
const DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_ALUGUEL = URL_BASE + "/Dashboard/UltimosImoveisAluguel";
const DASHBOARD_RECUPERAR_REPASSES_DO_DIA = URL_BASE + "/Dashboard/RepassesDoDia";
const DASHBOARD_RECUPERAR_REPASSES_ATRASADOS = URL_BASE + "/Dashboard/RepassesAtrasados";
const DASHBOARD_RECUPERAR_REPASSES_MES_ANTERIOR = URL_BASE + "/Dashboard/RepassesMesAnterior";
const DASHBOARD_RECUPERAR_CONTAS_PAGAR_DO_DIA = URL_BASE + "/Dashboard/ContasAPagarDoDia";
const DASHBOARD_RECUPERAR_CONTAS_PAGAR_ATRASADAS = URL_BASE + '/Dashboard/ContasAPagarAtrasadas';
const DASHBOARD_RECUPERAR_CONTAS_RECEBER_DO_DIA = URL_BASE + '/Dashboard/ContasAReceberDoDia';
const DASHBOARD_RECUPERAR_CONTAS_RECEBER_ATRASADAS = URL_BASE + '/Dashboard/ContasAReceberAtrasadas'
const DASHBOARD_RECUPERAR_CONTRATOS_REAJUSTE = URL_BASE + '/Dashboard/ContratosReajuste';
const DASHBOARD_RECUPERAR_CONTRATOS_RENOVAR = URL_BASE + '/Dashboard/ContratosRenovar';
const DASHBOARD_RECUPERAR_DESEMPENHO_LOCACAO = URL_BASE + '/Dashboard/DesempenhoLocacao';
const DASHBOARD_RECUPERAR_QUANTIDADE_ALUGUEIS_ATRASADOS = URL_BASE + '/Dashboard/RecuperarSumarioAlugueisAtrasados';
const DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_AVULSOS = URL_BASE + '/Dashboard/RecuperarSumarioBoletosAvulsos';
const DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_ACORDO = URL_BASE + '/Dashboard/RecuperarSumarioBoletosAcordo';
const DASHBOARD_RECUPERAR_VISTORIAS_NO_MES = URL_BASE + "/Dashboard/VistoriasNoMes"
const DASHBOARD_RECUPERAR_VACANCIA_IMOVEIS = URL_BASE + "/Dashboard/RecuperarVacanciaImoveis";
const DASHBOARD_RECUPERAR_NEGOCIACAO_IMOVEIS = URL_BASE + "/Dashboard/RecuperarTempoNegociacaoImoveis";

const DESTAQUES_SITE_RECUPERAR_DESTAQUES_PRINCIPAIS = URL_BASE + "/DestaquesSite/RecuperarDestaquesPrincipais";
const DESTAQUES_SITE_GRAVAR_DESTAQUE_PRINCIPAL = URL_BASE + "/DestaquesSite/GravarDestaquePrincipal";
const DESTAQUES_SITE_REMOVER_DESTAQUE_PRINCIPAL = URL_BASE + "/DestaquesSite/RemoverDestaquePrincipal";

const EXTRATOS_DIMOB_LISTAR_PROPRIETARIOS = URL_BASE + "/ExtratosDimob/RecuperarProprietarios";
const EXTRATOS_DIMOB_GERAR_EXTRATOS = URL_BASE + "/ExtratosDimob/GerarExtratos";
const EXTRATOS_DIMOB_ENVIAR_EXTRATOS = URL_BASE + "/ExtratosDimob/EnviarExtratos"
const EXTRATOS_DIMOB_GERAR_ETIQUETAS = URL_BASE + "/ExtratosDimob/GerarEtiquetas";
const EXTRATOS_DIMOB_GERAR_ARQUIVO_IMPORTACAO = URL_BASE + "/ExtratosDimob/GerarArquivoImportacao";

const VISUALIZAR_NOTIFICACAO = URL_BASE + "/Usuarios/VisualizarNotificacao";
const ENCERRAR_SESSAO = URL_BASE + "/Usuarios/EncerrarSessao";

const FORMULARIOS_LISTAR = URL_BASE + "/Formularios/Listar";
const FORMULARIOS_RECUPERAR_FORMULARIO = URL_BASE + "/Formularios/Recuperar";
const FORMULARIOS_REMOVER = URL_BASE + "/Formularios/Remover";
const FORMULARIOS_GRAVAR = URL_BASE + "/Formularios/Upload";
const FORMULARIOS_DOWNLOAD = URL_BASE + "/Formularios/Download";
const FORMULARIOS_GERAR = URL_BASE + "/Formularios/Gerar";
const FORMULARIOS_GERAR_RECIBO_COMISSAO = URL_BASE + "/Formularios/GerarReciboComissao";
const FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO = URL_BASE + "/Formularios/GerarReciboComissaoUnico";
const FORMULARIOS_GERAR_RECIBO_PAGAMENTO_PARCIAL_ALUGUEL = URL_BASE + "/Formularios/GerarReciboParcialUnico"
const FORMULARIOS_RECUPERAR = URL_BASE + "/Formularios/ListarDiretoriosFormulario";
const FORMULARIOS_RECUPERAR_PERGUNTAS = URL_BASE + "/Formularios/RecuperarPerguntas";
const FORMULARIOS_CRIAR_DIRETORIO = URL_BASE + "/Formularios/CriarDiretorio";
const FORMULARIOS_REMOVER_DIRETORIO = URL_BASE + "/Formularios/RemoverDiretorio";
const FORMULARIOS_LISTAR_DIRETORIOS = URL_BASE + "/Formularios/ListarDiretorios";
const FORMULARIOS_SELECIONAR_DIRETORIO = URL_BASE + "/Formularios/SelecionarDiretorio";

//FORNECEDORES
const FORNECEDORES_LISTAR = URL_BASE + "/Fornecedores/Listar";
const FORNECEDORES_GRAVAR = URL_BASE + "/Fornecedores/Gravar";
const FORNECEDORES_RECUPERAR = URL_BASE + "/Fornecedores/Recuperar";
const FORNECEDORES_REMOVER = URL_BASE + "/Fornecedores/Remover";
const FORNECEDORES_GRAVAR_CONTA = URL_BASE + "/Fornecedores/GravarContaBancaria";
const FORNECEDORES_REMOVER_CONTA = URL_BASE + "/Fornecedores/RemoverContaBancaria"

//GRUPO_PLANO_CONTA
const GRUPO_PLANO_CONTA_LISTAR = URL_BASE + "/GrupoPlanoConta/Listar";
const GRUPO_PLANO_CONTA_GRAVAR = URL_BASE + "/GrupoPlanoConta/Gravar";
const GRUPO_PLANO_CONTA_RECUPERAR = URL_BASE + "/GrupoPlanoConta/Recuperar";
const GRUPO_PLANO_CONTA_REMOVER = URL_BASE + "/GrupoPlanoConta/Remover";

//TIPO_DESPESA
const TIPO_CONTA_GRAVAR = URL_BASE + "/TipoConta/Gravar";
const TIPO_CONTA_LISTAR = URL_BASE + "/TipoConta/Listar";
const TIPO_CONTA_RECUPERAR = URL_BASE + "/TipoConta/Recuperar";
const TIPO_CONTA_REMOVER = URL_BASE + "/TipoConta/Remover";

//SUB_GRUPO_CONTA
const SUB_GRUPO_LISTAR = URL_BASE + "/SubGrupoPlanoConta/Listar" 
const SUB_GRUPO_GRAVAR = URL_BASE + "/SubGrupoPlanoConta/Gravar"
const SUB_GRUPO_RECUPERAR = URL_BASE + "/SubGrupoPlanoConta/Recuperar"
const SUB_GRUPO_REMOVER = URL_BASE + "/SubGrupoPlanoConta/Remover"

const IMAGENS_UPLOAD = URL_BASE + "/Imagens/Gravar";
const IMAGENS_REORDENAR = URL_BASE + "/Imagens/Reordenar";
const IMAGENS_EXIBIR_NA_FICHA = URL_BASE + "/Imagens/ExibirNaFicha";
const IMAGENS_REMOVER = URL_BASE + "/Imagens/Remover";

//REMESSAS_BANCARIAS_FINANCEIRO
const LISTAR_LANCAMENTOS_REMESSA = URL_BASE + '/RemessasFinanceiro/ListarLancamentosRemessa';
const REMESSAS_FINANCEIRO_RECUPERAR_NUMERO_REMESSA = URL_BASE + '/RemessasFinanceiro/RecuperarNumeroDaRemessa';
const REMESSAS_FINANCEIRO_GERAR_ARQUIVO_REMESSA = URL_BASE + '/RemessasFinanceiro/GerarArquivoRemessa';

const IMAGENS_CARROSSEL_UPLOAD = URL_BASE + "/ImagensCarrossel/Gravar";
const IMAGENS_CARROSSEL_LISTAR = URL_BASE + "/ImagensCarrossel/Listar";
const IMAGENS_CARROSSEL_REMOVER = URL_BASE + "/ImagensCarrossel/Remover";

//IMOBILIARIA
const IMOBILIARIAS_RECUPERAR_PARAMETROS = URL_BASE + "/Imobiliarias/RecuperarParametros";
const IMOBILIARIAS_GRAVAR_PARAMETROS = URL_BASE + "/Imobiliarias/GravarParametros";
const IMOBILIARIAS_ALTERAR_LOGOMARCA = URL_BASE + "/Imobiliarias/AlterarLogomarca";
const IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE = URL_BASE + "/ParametrosSite/Recuperar";
const IMOBILIARIAS_GRAVAR_PARAMETROS_SITE = URL_BASE + "/ParametrosSite/Gravar";
const IMOBILIARIAS_UPLOAD_BANNER_QUEM_SOMOS = URL_BASE + "/ParametrosSite/AdicionarImagemBannerQuemSomos";
const IMOBILIARIAS_REMOVER_BANNER_QUEM_SOMOS = URL_BASE + "/ParametrosSite/RemoverImagemBannerQuemSomos";
const IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_1 = URL_BASE + "/ParametrosSite/AdicionarImagemBannerPrincipalView1";
const IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_1 = URL_BASE + "/ParametrosSite/RemoverImagemBannerPrincipalView1";
const IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_2 = URL_BASE + "/ParametrosSite/AdicionarImagemBannerPrincipalView2";
const IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_2 = URL_BASE + "/ParametrosSite/RemoverImagemBannerPrincipalView2";
const IMOBILIARIAS_GRAVAR_DADOS_IMOBILIARIA_SITE = URL_BASE + "/ParametrosSite/GravarDadosImobiliariaSite"
const IMOBILIARIAS_ALTERAR_IMAGEM_SITE = URL_BASE + "/Imobiliarias/AlterarImagemSite";
const IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_ANIVERSARIO = URL_BASE + "/ParametrosEmailAniversario/Recuperar";
const IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_ANIVERSARIO = URL_BASE + "/ParametrosEmailAniversario/Gravar";
const IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_PROPRIETARIO = URL_BASE + "/ParametrosEmailAniversario/GravarImagemProprietario";
const IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_LOCATARIO = URL_BASE + "/ParametrosEmailAniversario/GravarImagemLocatario";

const IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_CAMPANHA = URL_BASE + "/ParametrosEmailCampanha/Recuperar";
const IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_CAMPANHA = URL_BASE + "/ParametrosEmailCampanha/Gravar";
const IMOBILIARIAS_GRAVAR_IMAGENS_EMAIL_CAMPANHA = URL_BASE + "/ParametrosEmailCampanha/GravarImagem";
const IMOBILIARIAS_REMOVER_IMAGEM_EMAIL_CAMPANHA = URL_BASE + "/ParametrosEmailCampanha/RemoverImagem";

//IMOVEIS
const IMOVEIS_LISTAR = URL_BASE + "/Imoveis/Listar";
const IMOVEIS_RECUPERAR = URL_BASE + "/Imoveis/Recuperar";
const IMOVEIS_RECUPERAR_ALUGUEL_ATIVO = URL_BASE + "/Imoveis/RecuperarAluguelAtivo";
const IMOVEIS_GRAVAR = URL_BASE + "/Imoveis/Gravar";
const IMOVEIS_DISPONIBILIZAR_VENDA = URL_BASE + "/Imoveis/DisponibilizarParaVenda";
const IMOVEIS_DISPONIBILIZAR_ALUGUEL = URL_BASE + "/Imoveis/DisponibilizarParaAluguel";
const IMOVEIS_DISPONIBILIZAR = URL_BASE + "/Imoveis/Disponibilizar";
const IMOVEIS_INDISPONIBILIZAR = URL_BASE + "/Imoveis/Indisponibilizar";
const IMOVEIS_ARQUIVAR = URL_BASE + "/Imoveis/Arquivar";
const IMOVEIS_DESARQUIVAR = URL_BASE + "/Imoveis/Desarquivar";
const IMOVEIS_REMOVER = URL_BASE + "/Imoveis/Remover";
const IMOVEIS_GRAVAR_LOCALIZACAO = URL_BASE + "/Imoveis/GravarLocalizacao";
const IMOVEIS_RECUPERAR_ULTIMO_ID = URL_BASE + "/Imoveis/RecuperarUltimoIdCadastrado";
const IMOVEIS_RECUPERAR_VISITA = URL_BASE + "/Imoveis/RecuperarVisita"; 
const IMOVEIS_RECUPERAR_VISITA_IMOVEL = URL_BASE + "/Imoveis/RecuperarVisitaImovel";
const IMOVEIS_GRAVAR_AVALIACAO_VISITA = URL_BASE + "/Imoveis/GravarAvaliacaoVisita";
const IMOVEIS_GRAVAR_VISITA = URL_BASE + "/Imoveis/GravarVisita";
const IMOVEIS_REMOVER_VISITA = URL_BASE + "/Imoveis/RemoverVisita";
const IMOVEIS_RESERVAR_IMOVEL = URL_BASE + "/Imoveis/ReservarImovel";
const IMOVEIS_PRORROGAR_RESERVA_IMOVEL = URL_BASE + "/Imoveis/ProrrogarReservaImovel";
const IMOVEIS_DESFAZER_RESERVA = URL_BASE + "/Imoveis/DesfazerReserva";
const IMOVEIS_ENTREGAR_CHAVE = URL_BASE + "/Imoveis/EntregarChave";
const IMOVEIS_RECEBER_CHAVE = URL_BASE + "/Imoveis/ReceberChave";
const IMOVEIS_GRAVAR_LANCAMENTO_FUTURO = URL_BASE + "/Imoveis/GravarLancamentoFuturo";
const IMOVEIS_REMOVER_LANCAMENTO_FUTURO = URL_BASE + "/Imoveis/RemoverLancamentoFuturo";
const IMOVEIS_CALCULAR_PRECO_METRO_QUADRADO = URL_BASE + "/Imoveis/CalcularPrecoMetroQuadrado";

//LANCAMENTOS
const LANCAMENTOS_RECUPERAR = URL_BASE + "/Lancamentos/Recuperar";
const LANCAMENTOS_GRAVAR = URL_BASE + "/Lancamentos/Gravar";
const LANCAMENTOS_PAGAR = URL_BASE + "/Lancamentos/Pagar";
const LANCAMENTOS_CANCELAR = URL_BASE + "/Lancamentos/CancelarPagamento";
const LANCAMENTOS_REMOVER = URL_BASE + "/Lancamentos/Remover";
const LANCAMENTOS_DEVOLVER_CHEQUE = URL_BASE + "/Lancamentos/DevolverCheque";
const LANCAMENTOS_BOLETO_GERAR = URL_BASE + "/Lancamentos/GerarBoleto";
const LANCAMENTOS_BOLETO_ENVIAR = URL_BASE + "/Lancamentos/EnviarBoleto";
const LANCAMENTOS_PRORROGAR = URL_BASE + '/Lancamentos/ProrrogarLancamento';
const LANCAMENTOS_CANCELAR_PRORROGACAO = URL_BASE + '/Lancamentos/CancelarProrrogacaoLancamento';
const LANCAMENTOS_CALCULAR = URL_BASE + '/Lancamentos/CalcularLancamento';

const LOGGER_LISTAR = URL_BASE + "/Logger/Listar";

const OBSERVACOES_RECUPERAR = URL_BASE + "/Observacoes/Recuperar";
const OBSERVACOES_GRAVAR = URL_BASE + "/Observacoes/Gravar";
const OBSERVACOES_REMOVER = URL_BASE + "/Observacoes/Remover";

const PARCERIAS_LISTAR_DISPONIVEIS_PARCERIA = URL_BASE + "/Parcerias/ListarDisponiveisParceria";
const PARCERIAS_GRAVAR = URL_BASE + "/Parcerias/Gravar";

const PARCERIAS_LISTAR = URL_BASE + "/Parcerias/Listar";
const PARCERIAS_RECUPERAR = URL_BASE + "/Parcerias/Recuperar";
const PARCERIAS_SOLICITAR_PARCERIA = URL_BASE + "/Parcerias/SolicitarParceria";
const PARCERIAS_ACEITAR_PARCERIA = URL_BASE + "/Parcerias/AceitarParceria";
const PARCERIAS_REJEITAR_PARCERIA = URL_BASE + "/Parcerias/RejeitarParceria";
const PARCERIAS_RECUPERAR_IMOBILIARIAS_PARCEIRAS = URL_BASE + "/Parcerias/RecuperarImobiliariasParceiras";
const PARCERIAS_RECUPERAR_IMOVEL = URL_BASE + "/Parcerias/RecuperarImovelParceiro";
const PARCERIAS_LISTAR_IMOVEIS_PARCEIROS = URL_BASE + "/Parcerias/ListarImoveisParceiros";
const PARCERIAS_GRAVAR_IMOVEIS = URL_BASE + "/Parcerias/Gravar";

const PERFIS_USUARIO_LISTAR = URL_BASE + "/PerfisUsuario/Listar";
const PERFIS_USUARIO_RECUPERAR = URL_BASE + "/PerfisUsuario/Recuperar";
const PERFIS_USUARIO_GRAVAR = URL_BASE + "/PerfisUsuario/Gravar";
const PERFIS_USUARIO_REMOVER = URL_BASE + "/PerfisUsuario/Remover";

const PLACAS_LISTAR = URL_BASE + "/Placas/Listar";
const PLACAS_GRAVAR_PLACA_NO_IMOVEL = URL_BASE + "/Placas/GravarPlacaNoImovel";
const PLACAS_REMOVER_PLACA_DO_IMOVEL = URL_BASE + "/Placas/RemoverPlacaDoImovel";
const PLACAS_RECUPERAR = URL_BASE + "/Placas/Recuperar";
const PLACAS_GRAVAR = URL_BASE + "/Placas/Gravar";
const PLACAS_REMOVER = URL_BASE + "/Placas/Remover";

//PLANO_CONTA
const PLANO_CONTA_LISTAR = URL_BASE + "/ContaPlanoConta/Listar";
const PLANO_CONTA_GRAVAR = URL_BASE + "/ContaPlanoConta/Gravar";
const PLANO_CONTA_RECUPERAR = URL_BASE + "/ContaPlanoConta/Recuperar";
const PLANO_CONTA_REMOVER = URL_BASE + "/ContaPlanoConta/Remover";

const PORTAIS_RECUPERAR = URL_BASE + "/Portais/RecuperarPortal";
const PORTAIS_GRAVAR = URL_BASE + "/Portais/Gravar";

//RECIBOS
const RECIBOS_LISTAR_RECIBOS_CONTRATO = URL_BASE + "/Recibos/ListarRecibosDoContrato";
const RECIBOS_GERAR_BOLETOS_EM_ABERTO = URL_BASE + "/Recibos/GerarBoletosEmAberto";
const RECIBOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL = URL_BASE + "/Recibos/EnviarBoletosEmAbertoPorEmail";
const RECIBOS_GERAR_DEMONSTRATIVO = URL_BASE + "/Recibos/GerarDemonstrativo";
const RECIBOS_ENVIAR_DEMONSTRATIVO_POR_EMAIL = URL_BASE + "/Recibos/EnviarDemonstrativoPorEmail";
const RECIBOS_GERAR_BOLETO = URL_BASE + "/Recibos/GerarBoleto";
const RECIBOS_ENVIAR_BOLETO_POR_EMAIL = URL_BASE + "/Recibos/EnviarBoleto";
const RECIBOS_CALCULAR_ALUGUEL = URL_BASE + "/Recibos/CalcularAluguel";
const RECIBOS_CALCULAR_REPASSE = URL_BASE + "/Recibos/CalcularRepasse";
const RECIBOS_BLOQUEAR_BAIXA = URL_BASE + "/Recibos/BloquearBaixa";
const RECIBOS_DESBLOQUEAR_BAIXA = URL_BASE + "/Recibos/DesbloquearBaixa";
const RECIBOS_CANCELAR_REGISTRO = URL_BASE + "/Recibos/CancelarRegistroRecibo"
const RECIBOS_PRORROGAR_BOLETO = URL_BASE + "/Recibos/ProrrogarRecibo";
const RECIBOS_CANCELAR_PRORROGACAO = URL_BASE + "/Recibos/CancelarProrrogacao";
const RECIBOS_EFETUAR_PAGAMENTO = URL_BASE + "/Recibos/EfetuarPagamento";
const RECIBOS_CANCELAR_PAGAMENTO = URL_BASE + "/Recibos/CancelarPagamento";
const RECIBOS_LIBERAR_REPASSE = URL_BASE + "/Recibos/LiberarRepasse";
const RECIBOS_LIBERAR_LOTE_REPASSE_NA_IMOBILIARIA = URL_BASE + "/Recibos/LiberarRepasseEmLoteNaImobiliaria";
const RECIBOS_CANCELAR_REPASSE = URL_BASE + "/Recibos/CancelarRepasse";
const RECIBOS_GRAVAR_ITEM = URL_BASE + "/Recibos/GravarItemRecibo";
const RECIBOS_REMOVER_ITEM = URL_BASE + "/Recibos/RemoverItemRecibo";
const RECIBOS_LISTAR_BAIXAS = URL_BASE + "/Recibos/ListarBaixas";
const RECIBOS_LISTAR_REPASSES = URL_BASE + "/Recibos/ListarRepasses";
const RECIBOS_LIBERAR_REPASSE_EM_LOTE = URL_BASE + "/Recibos/LiberarRepasseEmLote";
const RECIBOS_GERAR_DEMONSTRATIVOS = URL_BASE + "/Recibos/GerarDemonstrativos";
const RECIBOS_CANCELAR_PAGAMENTO_BENEFICIARIO = URL_BASE + "/Recibos/CancelarPagamentoBeneficiario";
const RECIBOS_PAGAR_VALOR_EM_ABERTO = URL_BASE + "/Recibos/PagarReciboValorEmAberto";
const RECIBOS_CANCELAR_PAGAMENTOS_RECIBO_PARCIAL = URL_BASE + "/Recibos/CancelarPagamentosReciboParcial";
const RECIBOS_CALCULAR_VALOR_EM_ABERTO = URL_BASE + "/Recibos/CalcularAluguelEmAberto";
const RECIBOS_ALTERAR_PERIODO = URL_BASE + "/Recibos/AlterarPeriodoRecibo";

//RELATORIOS
const RELATORIOS_GERAR = URL_BASE + "/Relatorios/Gerar";
const RELATORIOS_GERAR_DIMOB = URL_BASE + "/Relatorios/GerarDimob";
const RELATORIOS_GERAR_RELATORIO_CLIENTES_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioClientesAluguel";
const RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA = URL_BASE + "/Relatorios/GerarRelatorioClientesVenda";
const RELATORIOS_GERAR_RELATORIO_CONTRATOS_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioContratosAluguel";
const RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL = URL_BASE + "/Relatorios/GerarRelatorioImoveisAluguel";
const RELATORIOS_ENVIAR_POR_EMAIL = URL_BASE + "/Relatorios/EnviarPorEmail";
const RELATORIOS_GERAR_VISTORIA = URL_BASE + "/Relatorios/GerarVistoria";
const RELATORIOS_GERAR_LAUDO_VISTORIA = URL_BASE + "/Relatorios/GerarLaudoVistoria"
const RELATORIOS_ENVIAR_LAUDO_VISTORIA = URL_BASE + "/Relatorios/EnviarLaudoVistoriaEmail"

const REMESSAS_LISTAR_BOLETOS_REMESSA = URL_BASE + "/Remessas/ListarBoletosRemessa";
const REMESSAS_LISTAR_REPASSES_REMESSA = URL_BASE + "/RemessasPagamento/ListarBoletosPagamentoRemessa";
const REMESSAS_GERAR_ARQUIVO_REMESSA = URL_BASE + "/Remessas/GerarArquivoRemessa";
const REMESSAS_GERAR_ARQUIVO_REMESSA_PAGAMENTOS = URL_BASE + "/RemessasPagamento/GerarArquivoRemessa"
const REMESSAS_RECUPERAR_NUMERO_DA_REMESSA = URL_BASE + "/Remessas/RecuperarNumeroDaRemessa";
const REMESSAS_RECUPERAR_NUMERO_DA_REMESSA_PAGAMENTOS = URL_BASE + "/RemessasPagamento/RecuperarNumeroDaRemessa"

const TITULOS_API_REGISTRAR_CORA = URL_BASE + "/CoraApi/RegistrarBoletos"
const TITULOS_API_GET_SALDO_CORA = URL_BASE + "/CoraApi/GetSaldo"
const TITULOS_API_RECUPERAR_CORA = URL_BASE + "/CoraApi/ListarTitulosCora"
const TITULOS_API_PAGAR_RECIBO_STAGE_CORA = URL_BASE + "/CoraApi/PagarReciboStage"
const TITULOS_API_PAGAR_BOLETO_AVULSO_STAGE_CORA = URL_BASE + "/CoraApi/PagarBoletoAvulsoStage"
const TITULOS_API_CANCELAR_RECIBO_CORA = URL_BASE + "/CoraApi/CancelarReciboCora"
const TITULOS_API_CANCELAR_BOLETO_AVULSO_CORA = URL_BASE + "/CoraApi/CancelarBoletoAvulsoCora"
const TITULOS_API_RECUPERAR_EXTRATO_CORA = URL_BASE + "/CoraApi/RecuperarExtrato"
const TITULOS_API_REGISTRAR_ASAAS = URL_BASE + "/AsaasApi/RegistrarBoletos";
const TITULOS_API_RECUPERAR_ASAAS = URL_BASE + "/AsaasApi/ListarTitulosAsaas"
const TITULOS_API_RECUPERAR_EXTRATO_ASAAS = URL_BASE + "/AsaasApi/RecuperarExtrato"
const TITULOS_API_CANCELAR_RECIBO_ASAAS = URL_BASE + "/AsaasApi/CancelarReciboAsaas"
const TITULOS_API_CANCELAR_BOLETO_AVULSO_ASAAS = URL_BASE + "/AsaasApi/CancelarBoletoAvulsoAsaas"
const TITULOS_API_ATUALIZAR_TITULO_ASAAS = URL_BASE + "/AsaasApi/AtualizarTituloAsaas";

const USUARIOS_LISTAR = URL_BASE + "/Usuarios/Listar";
const USUARIOS_RECUPERAR = URL_BASE + "/Usuarios/Recuperar";
const USUARIOS_GRAVAR = URL_BASE + "/Usuarios/Gravar";
const USUARIOS_REMOVER = URL_BASE + "/Usuarios/Remover";
const USUARIOS_REMOVER_CONTA_BANCARIA = URL_BASE + "/Usuarios/RemoverContaBancaria";
const USUARIOS_GRAVAR_CONTA_BANCARIA = URL_BASE + "/Usuarios/GravarContaBancaria";
const USUARIOS_REATIVAR = URL_BASE + "/Usuarios/Reativar";
const USUARIOS_ATIVAR = URL_BASE + "/Usuarios/Ativar";
const USUARIOS_DESATIVAR = URL_BASE + "/Usuarios/Desativar";

const VALIDAR_ACESSO = URL_BASE + "/Usuarios/ValidarAcesso";

//VENDAS
const VENDAS_APROVAR = URL_BASE + "/Vendas/Aprovar";
const VENDAS_VERIFICAR_APROVACAO = URL_BASE + "/Vendas/VerificarAprovacao";
const VENDAS_DESAPROVAR = URL_BASE + "/Vendas/Desaprovar";
const VENDAS_CANCELAR = URL_BASE + "/Vendas/Cancelar";
const RESTAURAR_VENDA = URL_BASE + "/Vendas/Restaurar";
const VENDAS_GRAVAR = URL_BASE + "/Vendas/Gravar";
const VENDAS_REMOVER = URL_BASE + "/Vendas/Remover";
const VENDAS_LISTAR = URL_BASE + "/Vendas/Listar";
const VENDAS_RECUPERAR = URL_BASE + "/Vendas/Recuperar";
const VENDAS_PAGAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/PagarPagamentoComissao"; 
const VENDAS_PAGAR_COMISSAO_COMPLETA = URL_BASE + "/Vendas/PagarComissaoCompleta";
const VENDAS_GRAVAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/GravarPagamentoComissao";
const VENDAS_CANCELAR_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/CancelarPagamentoComissao";
const VENDAS_REMOVER_PAGAMENTO_COMISSAO = URL_BASE + "/Vendas/RemoverPagamentoComissao";

const VISTORIAS_AGENDAR = URL_BASE + "/Vistorias/Agendar";
const VISTORIAS_CANCELAR = URL_BASE + "/Vistorias/Cancelar";
const VISTORIAS_RETOMAR = URL_BASE + "/Vistorias/Retomar";
const VISTORIAS_REMOVER = URL_BASE + "/Vistorias/Remover";
const VISTORIAS_FORCAR_CONCLUSAO = URL_BASE + "/Vistorias/ForcarConclusao";
const VISTORIAS_LISTAR = URL_BASE + "/Vistorias/Listar";
const VISTORIAS_GRAVAR_COMODOS = URL_BASE + "/Vistorias/GravarComodos"
const VISTORIAS_REMOVER_COMODO = URL_BASE + "/Vistorias/RemoverComodo"
const VISTORIAS_GRAVAR_IMAGEM = URL_BASE + "/Vistorias/GravarImagem"
const VISTORIAS_REMOVER_IMAGEM = URL_BASE + "/Vistorias/RemoverImagem"
const VISTORIAS_ATUALIZAR_COMODO = URL_BASE + "/Vistorias/AtualizarComodo"
const VISTORIAS_GRAVAR_ITEM_COMODO = URL_BASE + "/Vistorias/GravarItensComodo"
const VISTORIAS_REMOVER_ITEM_COMODO = URL_BASE + "/Vistorias/RemoverItemComodo";
const VISTORIAS_ATUALIZAR_ITEM_COMODO = URL_BASE + "/Vistorias/AtualizarItemComodo";
const VISTORIAS_GRAVAR_DETALHE_ITEM = URL_BASE + "/Vistorias/GravarDetalheItemComodo"
const VISTORIAS_ATUALIZAR_DESCRICAO_DETALHE = URL_BASE + "/Vistorias/AtualizarDescricaoDetalhe"
const VISTORIAS_REMOVER_DETALHE = URL_BASE + "/Vistorias/RemoverDetalhe"
const VISTORIAS_ATUALIZAR_OBSERVACAO_GERAL = URL_BASE + "/Vistorias/AtualizarObservacoesGerais";
const VISTORIAS_CONCLUIR = URL_BASE + "/Vistorias/Concluir"

const CLICK_SIGN_LISTAR_DOCUMENTOS = URL_BASE + "/ZapSign/ListarDocumentos";
const CLICK_SIGN_CRIAR_ASSINATURA = URL_BASE + "/ZapSign/CriarAssinatura";
const CLICK_SIGN_LISTAR_ASSINATURAS = URL_BASE + "/ZapSign/ListarAssinaturas";
const CLICK_SIGN_GRAVAR_SIGNATARIOS = URL_BASE + "/ZapSign/GravarSignatarios";
const CLICK_SIGN_SOLICITAR_ASSINATURAS = URL_BASE + "/ZapSign/SolicitarAssinaturas";
const ZAP_SIGN_LISTAR_ENVOLVIDOS_ALUGUEL = URL_BASE + "/ZapSign/ListarEnvolvidosAluguel"
const ZAP_SIGN_LISTAR_ENVOLVIDOS_VENDA = URL_BASE + "/ZapSign/ListarEnvolvidosVenda"
const ZAP_SIGN_LISTAR_ENVOLVIDOS_IMOVEL = URL_BASE + "/ZapSign/ListarEnvolvidosImovel"
const ZAP_SIGN_LISTAR_ENVOLVIDOS_VISTORIA = URL_BASE + "/ZapSign/ListarEnvolvidosVistoria"

export default {
  ADMINISTRADORAS_LISTAR,
  ADMINISTRADORAS_RECUPERAR,
  ADMINISTRADORAS_GRAVAR,
  ADMINISTRADORAS_REMOVER,
  ADMINISTRADORAS_ADICIONAR_CONDOMINIO,
  ADMINISTRADORAS_REMOVER_CONDOMINIO,

  ALUGUEIS_VERIFICAR_APROVACAO,
  ALUGUEIS_APROVAR,
  ALUGUEIS_DESAPROVAR,
  ALUGUEIS_CANCELAR_DESOCUPACAO,
  ALUGUEIS_DESOCUPAR,
  ALUGUEIS_CALCULAR_FINALIZACAO,
  ALUGUEIS_FINALIZAR_CONCLUIDO,
  ALUGUEIS_FINALIZAR,
  ALUGUEIS_FINALIZAR_COM_RESTRICOES,
  ALUGUEIS_CANCELAR_FINALIZACAO,
  ALUGUEIS_ATUALIZAR_SITUACAO_JURIDICA,
  ALUGUEIS_GRAVAR,
  ALUGUEIS_ALTERAR_DATA_REAJUSTE,
  ALUGUEIS_DESFAZER_ALTERACAO_DATA_REAJUSTE,
  ALUGUEIS_REMOVER,
  ALUGUEIS_DESARQUIVAR,
  ALUGUEIS_LISTAR,
  ALUGUEIS_RECUPERAR,
  ALUGUEIS_REAJUSTAR,
  ALUGUEIS_CANCELAR_REAJUSTE,
  ALUGUEIS_RENOVAR,
  ALUGUEIS_CANCELAR_RENOVACAO,
  ALUGUEIS_ALTERAR_RENOVACAO,
  ALUGUEIS_PRORROGAR,
  ALUGUEIS_CANCELAR_PRORROGACAO,
  ALUGUEIS_ALTERAR_TAXA_ADMINISTRACAO,
  ALUGUEIS_ULTIMA_TAXA_ADM_COMPLEMENTAR,
  ALUGUEIS_RECUPERAR_MES_SERIE_PARA_FINALIZACAO,
  ALUGUEIS_RECUPERAR_RECIBOS_DESCONTO_POR_ACORDO,
  ALUGUEIS_GRAVAR_DESCONTOS,
  ALUGUEIS_GRAVAR_DESCONTOS_SALDO_NEGATIVO,
  ALUGUEIS_REMOVER_DESCONTO,
  ALUGUEIS_ALTERAR_DATA_VENCIMENTO,
  ALUGUEIS_CANCELAR_ALTERACAO_VENCIMENTO,
  ALUGUEIS_EXIBIR_RESUMO_CONTRATO,
  ALUGUEIS_ALTERAR_VALOR_CONTRATO,
  ALUGUEIS_ALTERAR_CARENCIA_CONTRATO,
  ALUGUEIS_RECUPERAR_ENVOLVIDOS,
  ALUGUEIS_GRAVAR_LANCAMENTO_FUTURO,
  ALUGUEIS_REMOVER_LANCAMENTO_FUTURO,
  ALUGUEIS_REMOVER_COBRANCAS_RECIBO,
  ALUGUEIS_REMOVER_REGISTRO_RECIBOS_CONTRATO,

  ARQUIVOS_UPLOAD,
  ARQUIVOS_REMOVER,
  ARQUIVOS_CRIAR_DIRETORIO,
  ARQUIVOS_REMOVER_DIRETORIO,
  ARQUIVOS_LISTAR_DIRETORIOS,
  ARQUIVOS_SELECIONAR_DIRETORIO,

  ARQUIVO_RETORNO_LISTAR,
  ARQUIVO_RETORNO_PROCESSAR,

  ATENDIMENTOS_LISTAR,
  ATENDIMENTOS_RECUPERAR,
  ATENDIMENTOS_CONCLUIR_PRE_CADASTRO,
  ATENDIMENTOS_CONCLUIR_CRIACAO_PERFIL,
  ATENDIMENTOS_GRAVAR_IMOVEIS,
  ATENDIMENTOS_GRAVAR_VISITA,
  ATENDIMENTOS_GRAVAR_AVALIACAO_VISITA,
  ATENDIMENTOS_LISTAR_IMOVEIS_SEMELHANTES,
  ATENDIMENTOS_GERAR_PROPOSTA,
  ATENDIMENTOS_ENVIAR_PROPOSTA_ASSINATURA,
  ATENDIMENTOS_CONCLUIR_PROPOSTA_MANUALMENTE,
  ATENDIMENTOS_CANCELAR,
  ATENDIMENTOS_REMOVER,
  ATENDIMENTOS_CANCELAR_ASSINATURA_PROPOSTA,
  ATENDIMENTOS_ATUALIZAR_PRE_CADASTRO,
  ATENDIMENTOS_ATUALIZAR_CRIACAO_PERFIL,
  ATENDIMENTOS_REMOVER_IMOVEL_SEMELHANTE,
  ATENDIMENTOS_ENVIAR_PROPOSTA_MANUAL,
  ATENDIMENTOS_GERAR_PROPOSTA_MANUAL,
  ATENDIMENTOS_CANCELAR_PROPOSTA,

  BAIRROS_LISTAR,

  BOLETOS_AVULSOS_GRAVAR,
  BOLETOS_AVULSOS_REMOVER,
  BOLETOS_AVULSOS_RECUPERAR,
  BOLETOS_AVULSOS_GERAR,
  BOLETOS_AVULSOS_GERAR_BOLETOS,
  BOLETOS_AVULSOS_ENVIAR_BOLETO_POR_EMAIL,
  BOLETOS_AVULSOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL,
  BOLETOS_AVULSOS_LISTAR_BAIXAS,
  BOLETOS_AVULSOS_PAGAR,
  BOLETOS_AVULSOS_CANCELAR_PAGAMENTO,
  BOLETOS_AVULSOS_RECUPERAR_ENVOLVIDOS,
  BOLETOS_AVULSOS_PRORROGAR,
  BOLETOS_AVULSOS_CALCULAR,
  BOLETOS_AVULSOS_CANCELAR_PRORROGACAO,

  CAIXAS_RECUPERAR_CAIXA_ABERTO,
  CAIXAS_RECUPERAR_CHEQUES_NO_CAIXA,
  CAIXAS_ABRIR,
  CAIXAS_FECHAR,
  CAIXAS_GRAVAR_LANCAMENTO,
  CAIXAS_REMOVER_LANCAMENTO,
  CAIXAS_RECUPERAR_HISTORICO,
  CAIXAS_RECUPERAR_CAIXA_ANTERIOR,
  CAIXAS_RECUPERAR_HISTORICO_CHEQUE,
  CAIXAS_RECUPERAR_SALDO,

  CARACTERISTICAS_CONDOMINIO_LISTAR,
  CARACTERISTICAS_IMOVEL_LISTAR,

  CIDADES_LISTAR,

  CLIENTES_LISTAR,
  CLIENTES_RECUPERAR,
  CLIENTES_GRAVAR,
  CLIENTES_REATIVAR,
  CLIENTES_REMOVER,
  CLIENTES_GRAVAR_CONTATO_REALIZADO,
  CLIENTES_ATUALIZAR_CONTATO_REALIZADO,
  CLIENTES_REMOVER_CONTATO_REALIZADO,
  CLIENTES_GRAVAR_CONTA_BANCARIA,
  CLIENTES_REMOVER_CONTA_BANCARIA,
  CLIENTES_REMOVER_CONTA_BANCARIA_COM_REPASSE,
  CLIENTES_RECUPERAR_VISITA,
  CLIENTES_GRAVAR_VISITA,
  CLIENTES_REMOVER_VISITA,
  CLIENTES_GRAVAR_REGISTRO_COBRANCA,
  CLIENTES_LISTAR_COBRANCAS,
  COBRANCAS_REMOVER,
  CLIENTES_ATUALIZAR_REPRESENTANTE,

  CONDOMINIOS_LISTAR,
  CONDOMINIOS_GRAVAR,
  CONDOMINIOS_RECUPERAR,
  CONDOMINIOS_REMOVER,

  CONTAS_LISTAR,
  CONTAS_GRAVAR,
  CONTAS_APROVAR,
  CONTAS_DESAPROVAR,
  CONTAS_DUPLICAR,
  CONTAS_CRIAR_CONTA_MENSALIDADES,
  CONTAS_RECUPERAR,
  CONTAS_CANCELAR,
  CONTAS_REMOVER,
  CONTAS_FECHAR,
  CONTAS_REABRIR,

  CONTAS_BANCARIAS_LISTAR,
  CONTAS_BANCARIAS_RECUPERAR,
  CONTAS_BANCARIAS_GRAVAR,
  CONTAS_BANCARIAS_REMOVER,
  CONTAS_BANCARIAS_LISTAR_WEBHOOKS_ASAAS,
  CONTAS_BANCARIAS_REMOVER_WEBHOOK_ASAAS,
  CONTAS_BANCARIAS_ADICIONAR_WEBHOOK_PAGAMENTOS,

  DASHBOARD_LISTAR_IMOVEIS_MAPA,
  DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_VENDIDOS_GRAFICO,
  DASHBOARD_LISTAR_IMOVEIS_CAPTADOS_ALUGADOS_GRAFICO,
  DASHBOARD_LISTAR_ATENDIMENTOS_GRAFICO,
  DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL,
  DASHBOARD_RECUPERAR_SUMARIO_TIPO_IMOVEL_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_STATUS,
  DASHBOARD_RECUPERAR_SUMARIO_STATUS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_LOCATARIOS_INADIPLENTES,
  DASHBOARD_RECUPERAR_SUMARIO_RECEITA_ALUGUEL_MES,
  DASHBOARD_RECUPERAR_GESTAO_ALUGUEL_MES_ATUAL,
  DASHBOARD_RECUPERAR_SUMARIO_FOTOS,
  DASHBOARD_RECUPERAR_SUMARIO_FOTOS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO,
  DASHBOARD_RECUPERAR_SUMARIO_LOCALIZACAO_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_SUMARIO_ATENDIMENTO,
  DASHBOARD_IMOVEIS_CAPTADOS,
  DASHBOARD_IMOVEIS_VENDIDOS,
  DASHBOARD_RECUPERAR_ALUGUEIS_ATRASADOS,
  DASHBOARD_RECUPERAR_ALUGUEIS_DO_DIA,
  DASHBOARD_RECUPERAR_ALUGUEIS_MES_ANTERIOR,
  DASHBOARD_RECUPERAR_CONTRATOS_VENCIDOS,
  DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_VENDA,
  DASHBOARD_RECUPERAR_ULTIMOS_IMOVEIS_ALUGUEL,
  DASHBOARD_RECUPERAR_REPASSES_DO_DIA,
  DASHBOARD_RECUPERAR_REPASSES_ATRASADOS,
  DASHBOARD_RECUPERAR_REPASSES_MES_ANTERIOR,
  DASHBOARD_RECUPERAR_CONTAS_PAGAR_DO_DIA,
  DASHBOARD_RECUPERAR_CONTAS_PAGAR_ATRASADAS,
  DASHBOARD_RECUPERAR_CONTAS_RECEBER_DO_DIA,
  DASHBOARD_RECUPERAR_CONTAS_RECEBER_ATRASADAS,
  DASHBOARD_RECUPERAR_CONTRATOS_REAJUSTE,
  DASHBOARD_RECUPERAR_CONTRATOS_RENOVAR,
  DASHBOARD_RECUPERAR_DESEMPENHO_LOCACAO,
  DASHBOARD_RECUPERAR_QUANTIDADE_ALUGUEIS_ATRASADOS,
  DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_AVULSOS,
  DASHBOARD_RECUPERAR_QUANTIDADE_BOLETOS_ACORDO,
  DASHBOARD_RECUPERAR_VISTORIAS_NO_MES,
  DASHBOARD_RECUPERAR_VACANCIA_IMOVEIS,
  DASHBOARD_RECUPERAR_NEGOCIACAO_IMOVEIS,

  DESTAQUES_SITE_RECUPERAR_DESTAQUES_PRINCIPAIS,
  DESTAQUES_SITE_GRAVAR_DESTAQUE_PRINCIPAL,
  DESTAQUES_SITE_REMOVER_DESTAQUE_PRINCIPAL,

  EXTRATOS_DIMOB_LISTAR_PROPRIETARIOS,
  EXTRATOS_DIMOB_GERAR_EXTRATOS,
  EXTRATOS_DIMOB_ENVIAR_EXTRATOS,
  EXTRATOS_DIMOB_GERAR_ETIQUETAS,
  EXTRATOS_DIMOB_GERAR_ARQUIVO_IMPORTACAO,

  VISUALIZAR_NOTIFICACAO,
  ENCERRAR_SESSAO,

  FORMULARIOS_LISTAR,
  FORMULARIOS_RECUPERAR_FORMULARIO,
  FORMULARIOS_REMOVER,
  FORMULARIOS_GRAVAR,
  FORMULARIOS_DOWNLOAD,
  FORMULARIOS_GERAR,
  FORMULARIOS_GERAR_RECIBO_COMISSAO,
  FORMULARIOS_GERAR_RECIBO_COMISSAO_UNICO,
  FORMULARIOS_GERAR_RECIBO_PAGAMENTO_PARCIAL_ALUGUEL,
  FORMULARIOS_RECUPERAR,
  FORMULARIOS_RECUPERAR_PERGUNTAS,
  FORMULARIOS_CRIAR_DIRETORIO,
  FORMULARIOS_REMOVER_DIRETORIO,
  FORMULARIOS_LISTAR_DIRETORIOS,
  FORMULARIOS_SELECIONAR_DIRETORIO,

  //FORNECEDORES
  FORNECEDORES_LISTAR,
  FORNECEDORES_GRAVAR,
  FORNECEDORES_RECUPERAR,
  FORNECEDORES_REMOVER,
  FORNECEDORES_GRAVAR_CONTA,
  FORNECEDORES_REMOVER_CONTA,

  //GRUPO_PLANO_CONTA
  GRUPO_PLANO_CONTA_LISTAR,
  GRUPO_PLANO_CONTA_GRAVAR,
  GRUPO_PLANO_CONTA_RECUPERAR,
  GRUPO_PLANO_CONTA_REMOVER,

  //TIPO_DESPESA
  TIPO_CONTA_GRAVAR,
  TIPO_CONTA_LISTAR,
  TIPO_CONTA_RECUPERAR,
  TIPO_CONTA_REMOVER,

  //SUB_GRUPO_CONTA
  SUB_GRUPO_LISTAR,
  SUB_GRUPO_GRAVAR,
  SUB_GRUPO_RECUPERAR,
  SUB_GRUPO_REMOVER,

  IMAGENS_UPLOAD,
  IMAGENS_REORDENAR,
  IMAGENS_EXIBIR_NA_FICHA,
  IMAGENS_REMOVER,

  //REMESSAS_BANCARIAS_FINANCEIRO
  LISTAR_LANCAMENTOS_REMESSA,
  REMESSAS_FINANCEIRO_RECUPERAR_NUMERO_REMESSA,
  REMESSAS_FINANCEIRO_GERAR_ARQUIVO_REMESSA,

  IMAGENS_CARROSSEL_UPLOAD,
  IMAGENS_CARROSSEL_LISTAR,
  IMAGENS_CARROSSEL_REMOVER,

  IMOBILIARIAS_RECUPERAR_PARAMETROS,
  IMOBILIARIAS_GRAVAR_PARAMETROS,
  IMOBILIARIAS_ALTERAR_LOGOMARCA,
  IMOBILIARIAS_RECUPERAR_PARAMETROS_SITE,
  IMOBILIARIAS_GRAVAR_PARAMETROS_SITE,
  IMOBILIARIAS_UPLOAD_BANNER_QUEM_SOMOS,
  IMOBILIARIAS_REMOVER_BANNER_QUEM_SOMOS,
  IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_1,
  IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_1,
  IMOBILIARIAS_UPLOAD_BANNER_PRINCIPAL_VIEW_2,
  IMOBILIARIAS_REMOVER_BANNER_PRINCIPAL_VIEW_2,
  IMOBILIARIAS_GRAVAR_DADOS_IMOBILIARIA_SITE,
  IMOBILIARIAS_ALTERAR_IMAGEM_SITE,
  IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_ANIVERSARIO,
  IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_ANIVERSARIO,
  IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_PROPRIETARIO,
  IMOBILIARIAS_GRAVAR_IMAGEM_EMAIL_ANIVERSARIO_LOCATARIO,
  IMOBILIARIAS_RECUPERAR_PARAMETROS_EMAIL_CAMPANHA,
  IMOBILIARIAS_GRAVAR_PARAMETROS_EMAIL_CAMPANHA,
  IMOBILIARIAS_GRAVAR_IMAGENS_EMAIL_CAMPANHA,
  IMOBILIARIAS_REMOVER_IMAGEM_EMAIL_CAMPANHA,

  IMOVEIS_LISTAR,
  IMOVEIS_RECUPERAR,
  IMOVEIS_RECUPERAR_ALUGUEL_ATIVO,
  IMOVEIS_GRAVAR,
  IMOVEIS_DISPONIBILIZAR_VENDA,
  IMOVEIS_DISPONIBILIZAR_ALUGUEL,
  IMOVEIS_DISPONIBILIZAR,
  IMOVEIS_INDISPONIBILIZAR,
  IMOVEIS_ARQUIVAR,
  IMOVEIS_DESARQUIVAR,
  IMOVEIS_REMOVER,
  IMOVEIS_GRAVAR_LOCALIZACAO,
  IMOVEIS_RECUPERAR_ULTIMO_ID,
  IMOVEIS_RECUPERAR_VISITA,
  IMOVEIS_RECUPERAR_VISITA_IMOVEL,
  IMOVEIS_GRAVAR_AVALIACAO_VISITA,
  IMOVEIS_GRAVAR_VISITA,
  IMOVEIS_REMOVER_VISITA,
  IMOVEIS_RESERVAR_IMOVEL,
  IMOVEIS_PRORROGAR_RESERVA_IMOVEL,
  IMOVEIS_DESFAZER_RESERVA,
  IMOVEIS_ENTREGAR_CHAVE,
  IMOVEIS_RECEBER_CHAVE,
  IMOVEIS_GRAVAR_LANCAMENTO_FUTURO,
  IMOVEIS_REMOVER_LANCAMENTO_FUTURO,
  IMOVEIS_CALCULAR_PRECO_METRO_QUADRADO,

  LANCAMENTOS_RECUPERAR,
  LANCAMENTOS_GRAVAR,
  LANCAMENTOS_PAGAR,
  LANCAMENTOS_CANCELAR,
  LANCAMENTOS_REMOVER,
  LANCAMENTOS_DEVOLVER_CHEQUE,
  LANCAMENTOS_BOLETO_GERAR,
  LANCAMENTOS_BOLETO_ENVIAR,
  LANCAMENTOS_PRORROGAR,
  LANCAMENTOS_CANCELAR_PRORROGACAO,
  LANCAMENTOS_CALCULAR,

  LOGGER_LISTAR,

  OBSERVACOES_RECUPERAR,
  OBSERVACOES_GRAVAR,
  OBSERVACOES_REMOVER,

  PARCERIAS_LISTAR_DISPONIVEIS_PARCERIA,
  PARCERIAS_GRAVAR,

  PARCERIAS_LISTAR,
  PARCERIAS_RECUPERAR,
  PARCERIAS_SOLICITAR_PARCERIA,
  PARCERIAS_ACEITAR_PARCERIA,
  PARCERIAS_REJEITAR_PARCERIA,
  PARCERIAS_RECUPERAR_IMOBILIARIAS_PARCEIRAS,
  PARCERIAS_RECUPERAR_IMOVEL,
  PARCERIAS_LISTAR_IMOVEIS_PARCEIROS,
  PARCERIAS_GRAVAR_IMOVEIS,

  PERFIS_USUARIO_LISTAR,
  PERFIS_USUARIO_RECUPERAR,
  PERFIS_USUARIO_GRAVAR,
  PERFIS_USUARIO_REMOVER,

  PLACAS_LISTAR,
  PLACAS_GRAVAR_PLACA_NO_IMOVEL,
  PLACAS_REMOVER_PLACA_DO_IMOVEL,
  PLACAS_RECUPERAR,
  PLACAS_GRAVAR,
  PLACAS_REMOVER,

  PLANO_CONTA_LISTAR,
  PLANO_CONTA_GRAVAR,
  PLANO_CONTA_RECUPERAR,
  PLANO_CONTA_REMOVER,

  PORTAIS_RECUPERAR,
  PORTAIS_GRAVAR,

  RECIBOS_CANCELAR_REGISTRO,
  RECIBOS_LISTAR_RECIBOS_CONTRATO,
  RECIBOS_GERAR_BOLETOS_EM_ABERTO,
  RECIBOS_ENVIAR_BOLETOS_EM_ABERTO_POR_EMAIL,
  RECIBOS_GERAR_DEMONSTRATIVO,
  RECIBOS_ENVIAR_DEMONSTRATIVO_POR_EMAIL,
  RECIBOS_GERAR_BOLETO,
  RECIBOS_ENVIAR_BOLETO_POR_EMAIL,
  RECIBOS_CALCULAR_ALUGUEL,
  RECIBOS_CALCULAR_REPASSE,
  RECIBOS_BLOQUEAR_BAIXA,
  RECIBOS_DESBLOQUEAR_BAIXA,
  RECIBOS_PRORROGAR_BOLETO,
  RECIBOS_CANCELAR_PRORROGACAO,
  RECIBOS_EFETUAR_PAGAMENTO,
  RECIBOS_CANCELAR_PAGAMENTO,
  RECIBOS_LIBERAR_REPASSE,
  RECIBOS_LIBERAR_LOTE_REPASSE_NA_IMOBILIARIA,
  RECIBOS_CANCELAR_REPASSE,
  RECIBOS_GRAVAR_ITEM,
  RECIBOS_REMOVER_ITEM,
  RECIBOS_LISTAR_BAIXAS, 
  RECIBOS_LISTAR_REPASSES,
  RECIBOS_LIBERAR_REPASSE_EM_LOTE,
  RECIBOS_GERAR_DEMONSTRATIVOS,
  RECIBOS_CANCELAR_PAGAMENTO_BENEFICIARIO,
  RECIBOS_PAGAR_VALOR_EM_ABERTO,
  RECIBOS_CANCELAR_PAGAMENTOS_RECIBO_PARCIAL,
  RECIBOS_CALCULAR_VALOR_EM_ABERTO,
  RECIBOS_ALTERAR_PERIODO,

  RELATORIOS_GERAR,
  RELATORIOS_GERAR_DIMOB,
  RELATORIOS_GERAR_RELATORIO_CLIENTES_ALUGUEL,
  RELATORIOS_GERAR_RELATORIO_CLIENTES_VENDA,
  RELATORIOS_GERAR_RELATORIO_CONTRATOS_ALUGUEL,
  RELATORIOS_GERAR_RELATORIO_IMOVEIS_ALUGUEL,
  RELATORIOS_ENVIAR_POR_EMAIL,
  RELATORIOS_GERAR_VISTORIA,
  RELATORIOS_GERAR_LAUDO_VISTORIA,
  RELATORIOS_ENVIAR_LAUDO_VISTORIA,

  REMESSAS_LISTAR_BOLETOS_REMESSA,
  REMESSAS_LISTAR_REPASSES_REMESSA,
  REMESSAS_GERAR_ARQUIVO_REMESSA,
  REMESSAS_GERAR_ARQUIVO_REMESSA_PAGAMENTOS,
  REMESSAS_RECUPERAR_NUMERO_DA_REMESSA,
  REMESSAS_RECUPERAR_NUMERO_DA_REMESSA_PAGAMENTOS,

  TITULOS_API_REGISTRAR_CORA,
  TITULOS_API_GET_SALDO_CORA,
  TITULOS_API_REGISTRAR_ASAAS,
  TITULOS_API_RECUPERAR_CORA,
  TITULOS_API_PAGAR_RECIBO_STAGE_CORA,
  TITULOS_API_PAGAR_BOLETO_AVULSO_STAGE_CORA,
  TITULOS_API_CANCELAR_RECIBO_CORA,
  TITULOS_API_CANCELAR_BOLETO_AVULSO_CORA,
  TITULOS_API_RECUPERAR_EXTRATO_CORA,
  TITULOS_API_RECUPERAR_ASAAS,
  TITULOS_API_RECUPERAR_EXTRATO_ASAAS,
  TITULOS_API_CANCELAR_RECIBO_ASAAS,
  TITULOS_API_CANCELAR_BOLETO_AVULSO_ASAAS,
  TITULOS_API_ATUALIZAR_TITULO_ASAAS,

  USUARIOS_LISTAR,
  USUARIOS_RECUPERAR,
  USUARIOS_GRAVAR,
  USUARIOS_REMOVER,
  USUARIOS_REMOVER_CONTA_BANCARIA,
  USUARIOS_GRAVAR_CONTA_BANCARIA,
  USUARIOS_REATIVAR,
  USUARIOS_ATIVAR,
  USUARIOS_DESATIVAR,

  VALIDAR_ACESSO,

  VENDAS_APROVAR,
  VENDAS_VERIFICAR_APROVACAO,
  VENDAS_DESAPROVAR,
  VENDAS_CANCELAR,
  RESTAURAR_VENDA,
  VENDAS_GRAVAR,
  VENDAS_REMOVER,
  VENDAS_LISTAR,
  VENDAS_RECUPERAR,
  VENDAS_PAGAR_PAGAMENTO_COMISSAO,
  VENDAS_PAGAR_COMISSAO_COMPLETA,
  VENDAS_GRAVAR_PAGAMENTO_COMISSAO,
  VENDAS_CANCELAR_PAGAMENTO_COMISSAO,
  VENDAS_REMOVER_PAGAMENTO_COMISSAO,

  VISTORIAS_AGENDAR,
  VISTORIAS_CANCELAR,
  VISTORIAS_RETOMAR,
  VISTORIAS_REMOVER,
  VISTORIAS_FORCAR_CONCLUSAO,
  VISTORIAS_LISTAR,
  VISTORIAS_GRAVAR_COMODOS,
  VISTORIAS_REMOVER_COMODO,
  VISTORIAS_GRAVAR_IMAGEM,
  VISTORIAS_REMOVER_IMAGEM,
  VISTORIAS_ATUALIZAR_COMODO,
  VISTORIAS_GRAVAR_ITEM_COMODO,
  VISTORIAS_REMOVER_ITEM_COMODO,
  VISTORIAS_ATUALIZAR_ITEM_COMODO,
  VISTORIAS_GRAVAR_DETALHE_ITEM,
  VISTORIAS_ATUALIZAR_DESCRICAO_DETALHE,
  VISTORIAS_REMOVER_DETALHE,
  VISTORIAS_CONCLUIR,
  VISTORIAS_ATUALIZAR_OBSERVACAO_GERAL,

  CLICK_SIGN_LISTAR_DOCUMENTOS,
  CLICK_SIGN_CRIAR_ASSINATURA,
  CLICK_SIGN_LISTAR_ASSINATURAS,
  CLICK_SIGN_GRAVAR_SIGNATARIOS,
  CLICK_SIGN_SOLICITAR_ASSINATURAS,
  ZAP_SIGN_LISTAR_ENVOLVIDOS_ALUGUEL,
  ZAP_SIGN_LISTAR_ENVOLVIDOS_VENDA,
  ZAP_SIGN_LISTAR_ENVOLVIDOS_IMOVEL,
  ZAP_SIGN_LISTAR_ENVOLVIDOS_VISTORIA
}